module.exports = __webpack_public_path__ + "img/img8.2f4116a7.jpg";